<template>
  <aside class="w-full lg:w-72 rounded-xl bg-white shadow p-4">
    <h2 class="text-sm font-semibold text-neutral-600 mb-2">Mis Grupos</h2>

    <div
      class="space-y-2 max-h-[360px] pr-1"
      :class="groupList.length > 6 ? 'overflow-y-auto' : 'overflow-visible'"
    >
      <button
        class="w-full flex items-center justify-between rounded-lg px-3 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-100"
        :class="activeGroupId === 'all' ? 'bg-blue-50 text-blue-700' : ''"
        @click="$emit('select-group', 'all')"
      >
        <span>Todos los Grupos</span>
        <span class="text-xs text-neutral-500">{{ studentsCount }}</span>
      </button>

      <div
        v-for="(group, index) in groupList"
        :key="group.id"
        class="group relative"
      >
        <button
          class="w-full flex items-center justify-between rounded-lg px-3 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-100 pr-10"
          :class="activeGroupId === group.id ? 'bg-blue-50 text-blue-700' : ''"
          @click="$emit('select-group', group.id)"
        >
          <span class="truncate">{{ group.name }}</span>
          <span class="w-8 text-right text-xs text-neutral-500 mr-4">
            {{ group.count }}
          </span>
        </button>

        <button
          class="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-md text-neutral-500 hover:bg-neutral-100 flex items-center justify-center z-10"
          @click.stop="$emit('toggle-menu', group.id)"
          aria-label="Acciones de grupo"
        >
          &#8942;
        </button>

        <div
          v-if="openGroupMenuId === group.id"
          class="absolute right-2 top-9 z-20 w-44 rounded-md border border-neutral-200 bg-white shadow-lg"
        >
          <button
            class="block w-full text-left px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
            @click="$emit('edit-group', group)"
          >
            Editar
          </button>
          <button
            class="block w-full text-left px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
            @click="$emit('clone-group', group)"
          >
            Clonar
          </button>
          <button
            class="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50"
            @click="$emit('delete-group', group)"
          >
            Eliminar
          </button>
        </div>
      </div>
    </div>

    <button
      class="w-full px-4 py-2 rounded-md text-sm text-white bg-blue-600 mt-6"
      @click="$emit('create-group')"
    >
      Crear Grupo
    </button>
  </aside>
</template>

<script>
export default {
  name: "TeacherGroupsSidebar",
  props: {
    activeGroupId: {
      type: [String, Number],
      required: true,
    },
    studentsCount: {
      type: Number,
      required: true,
    },
    groupList: {
      type: Array,
      required: true,
    },
    openGroupMenuId: {
      type: [String, Number, null],
      default: null,
    },
  },
};
</script>
